import qrcode from 'qrcode-generator';
import { embedLogoInQrSvg } from './zippy-logo';

/** Deep link path scanned by the Zippy app — sessionId only, never clientToken. */
export const MERCHANT_PAYMENT_DEEP_LINK_PATH = 'merchant-payment';

/** Deep link scanned by the Zippy app — sessionId only, never clientToken. */
export function buildPaymentQrPayload(sessionId: string): string {
  return `zippy://${MERCHANT_PAYMENT_DEEP_LINK_PATH}/${sessionId}`;
}

type QrErrorCorrection = 'L' | 'M' | 'Q' | 'H';

/** Renders a QR code as an SVG string for embedding in the checkout UI. */
export function renderQrSvg(
  payload: string,
  cellSize = 4,
  errorCorrection: QrErrorCorrection = 'H',
  margin = 2,
): string {
  const qr = qrcode(0, errorCorrection);
  qr.addData(payload);
  qr.make();
  return qr.createSvgTag(cellSize, margin);
}

export function renderPaymentQrSvg(
  sessionId: string,
  cellSize = 4,
  errorCorrection: QrErrorCorrection = 'H',
): string {
  return renderQrSvg(buildPaymentQrPayload(sessionId), cellSize, errorCorrection);
}

/** Branded QR SVG with centred Zippy mark — matches merchant dashboard rendering. */
export function renderBrandedPaymentQrSvg(sessionId: string, cellSize = 4): string {
  return embedLogoInQrSvg(renderPaymentQrSvg(sessionId, cellSize, 'H'));
}

/** QR markup wrapper for the checkout UI. */
export function renderPaymentQrMarkup(sessionId: string, cellSize = 4): string {
  const svg = renderBrandedPaymentQrSvg(sessionId, cellSize);
  return `<div class="zippy-qr-stack">${svg}</div>`;
}

/** Plain QR markup for arbitrary URLs (e.g. app store links). */
export function renderUrlQrMarkup(url: string, cellSize = 4): string {
  const svg = renderQrSvg(url, cellSize, 'M');
  return `<div class="zippy-qr-stack zippy-qr-stack--plain">${svg}</div>`;
}
